import { Box, Grid, pn, Stack, useElementBreakpoints } from "@compass/core";
import { CustomFilters, Select } from "components";
import { NscCollegeFilter as NscCollegeFilterModel, NscCollegeFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const NscCollegeFilter = (props: {
  filter: NscCollegeFilterModel;
  setFilter: (filter: NscCollegeFilterModel) => void;
}) => {
  const [resource, setResource] = useState<NscCollegeFilterResource>({});
  const properties = resource.properties || [];
  const { breakpointsRef, largeFieldBreakpoints } = useElementBreakpoints();

  useEffect(() => {
    ApiService.nscColleges.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const schoolYearsField = () => {
    const propertyName = pn<NscCollegeFilterModel>("schoolYears");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        multiple
        value={resource.schoolYears?.filter((x) => props.filter.schoolYears?.includes(x.id))}
        options={resource.schoolYears}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolYears = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={largeFieldBreakpoints}>
        {schoolYearsField()}
      </Grid>
    </Grid>
  );
};
